
if (!customElements.get('card-product-item')) {
  customElements.define(
    'card-product-item',
    class cardProductItem extends HTMLElement {
      constructor() {
        super();
        this.reverseCheckboxes = this.querySelectorAll('input[name="reverse-option"]');
        this.isReverseProductImage = this.dataset.reverseProductImage === "true";
        this.allSlides = Array.from(this.querySelectorAll('.swiper-slide'));
        this.swiperContainer = this.querySelector('.js-product-card-images');
        this.swiperWrapper = this.swiperContainer?.querySelector('.swiper-wrapper');
        this.swiper = null;
        this.reverseCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => this.toggleImage(checkbox));
          checkbox.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              this.togglecheckbox(checkbox);
            }
          });
        });
        this.frontProductImageCount = parseInt(this.dataset.frontProductImageCount)
        this.reverseProductImageCount = parseInt(this.dataset.reverseProductImageCount)
        this.frontModelImageCount = parseInt(this.dataset.frontModelImageCount)
        this.reverseModelImageCount = parseInt(this.dataset.reverseModelImageCount)
      }
      connectedCallback() {
        if (!this.dataset.forceDefault) {
          const mediaQuery = window.matchMedia('(max-width: 1024px)');
          const updateCardType = () => {
            this.setAttribute('data-card-type', mediaQuery.matches ? 'simple-card' : 'classic-card');
          };
          mediaQuery.addEventListener('change', updateCardType);
          updateCardType();
        } else {
          this.setAttribute('data-card-type', 'classic-card');
        }
        this.initializeSwiper();
      }
      initializeSwiper(isToggle = true) {
        if (!this.swiperWrapper) return;
        let isReverseFilter = false;
        if (this.reverseCheckboxes && typeof this.reverseCheckboxes.forEach === 'function') {
          this.reverseCheckboxes.forEach(checkbox => {
            if (checkbox.dataset.isReverseFilter === "true") {
              isReverseFilter = true;
            }
          });
        }
        const urlParams = new URLSearchParams(window.location.search);
        const numberOfSlides =  urlParams.get('card_layout') ? parseInt(urlParams.get('card_layout')) : 4;
        if(numberOfSlides == 6 && window.matchMedia('(min-width: 1025px)').matches){
          document.querySelector('.js-product-grid-collection')?.classList.add("simplified-grid-view");
          this.setAttribute('data-card-type','simple-card');
          var checkedItm = this.querySelector('input.simplified-layout[name="reverse-option"]')
        } else {
          if(window.matchMedia('(min-width: 1025px)').matches) {
            var checkedItm = this.querySelector('input.default-layout[name="reverse-option"]')
            document.querySelector('.js-product-grid-collection')?.classList.remove("simplified-grid-view");
            this.setAttribute('data-card-type','classic-card');
          } else {
            document.querySelector('.js-product-grid-collection')?.classList.add("simplified-grid-view");
            this.setAttribute('data-card-type','simple-card');
            var checkedItm = this.querySelector('input.simplified-layout[name="reverse-option"]')
          }
        }
        const viewParam =  urlParams.get('image_view') ? urlParams.get('image_view').charAt(0).toUpperCase() + urlParams.get('image_view').slice(1) : 'Product';
        const altText = isReverseFilter || checkedItm?.checked ? `Reverse ${viewParam} Image` : `Front ${viewParam} Image`;

        const altMap = {
          "Front Product Image": ["Front Model Image", this.frontProductImageCount],
          "Reverse Product Image": ["Reverse Model Image", this.reverseProductImageCount],
          "Front Model Image": ["Front Product Image", this.frontModelImageCount],
          "Reverse Model Image": ["Reverse Product Image", this.reverseModelImageCount]
        };
        
      
        let alt = altText;
        if (altMap[alt] && altMap[alt][1] <= 0) {
          alt = altMap[alt][0];
        }
      
        let shown = this.allSlides.filter(slide => slide.getAttribute('data-alt')?.includes(alt));

        
        const altPairs = {
          "Front Product Image": "Front Model Image",
          "Front Model Image": "Front Product Image",
          "Reverse Product Image": "Reverse Model Image",
          "Reverse Model Image": "Reverse Product Image"
        };
      
        const extraAlt = altPairs[alt];
        if (extraAlt) {
          const extraImages = this.allSlides.filter(slide => slide.getAttribute('data-alt')?.includes(extraAlt));
          shown.push(...extraImages);
        }
        
        if (shown.length === 0) shown = [this.allSlides[0]];
        if (numberOfSlides == 6) shown = [shown[0]];

        if (this.dataset.noCarousel) {
          shown = [shown[0]]
        } 
        
        this.swiperWrapper.innerHTML = '';
        shown.forEach(slide => slide && this.swiperWrapper.appendChild(slide.cloneNode(true)));
      
        isToggle && this.animateFade();
      
        if (shown.length < 2) {
          this.swiper?.destroy();
          return;
        }

        this.swiper?.destroy();
        this.swiper = new Swiper(this.swiperContainer, {
          slidesPerView: 1,
          effect: 'fade',
          speed: 500,
          loop: true,
          noSwipingClass: "swiper-slide",
          noSwiping : this.dataset.stopScroll ? true : false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });
      }

      animateFade() {
        this.swiperContainer?.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration: 2000, easing: 'ease', fill: 'forwards' }
        );
      }

      togglecheckbox(checkbox) {
        checkbox.checked ? checkbox.checked = false : checkbox.checked = true;
        this.toggleImage()
      }
      toggleImage(checkbox) {
        var isSimplified = this.dataset.cardType == "simple-card" ? true : false;
        if(isSimplified){
          var checkedItm = this.querySelector('input.simplified-layout[name="reverse-option"]')
        } else {
          var checkedItm = this.querySelector('input.default-layout[name="reverse-option"]')
        }
        const imageType = checkedItm.dataset.imageOption;
        const altText = `${checkedItm?.checked ? 'Reverse' : 'Front'} ${imageType} Image`;
        // if(this.isReverseProductImage) { 
          this.initializeSwiper(altText, true, isSimplified ? 6 : 4);
        // } 
      }
    }
  );
}

if (!customElements.get('collection-image-switch')) {
  customElements.define(
    'collection-image-switch',
    class imageSwitcher extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('button');
        this.buttons?.forEach(button => button.addEventListener('click', this.handleClick.bind(this)));
      }
      handleClick({ target }) {
        var image_view =  document.querySelector('input[name="image_view"]');
        if (target.classList.contains('active')) {
          return;
        }
        this.buttons.forEach(button => button.classList.toggle('active', button === target));
        image_view.value = target.value;
        window.updateURLHash({'image_view': target.value});
        this.updateCards();
      }
      updateCards() {
        this.cards = this.closest('.shopify-section').querySelectorAll('card-product-item');
        this.cards.forEach(card => {
          card.initializeSwiper();
        });
      }
    }
  );
}

if (!customElements.get('collection-layout-switch')) {
  customElements.define(
    'collection-layout-switch',
    class layoutSwitch extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('button');
        this.cards = document.querySelectorAll('card-product-item');
        this.buttons?.forEach(button => button.addEventListener('click', this.handleClick.bind(this)));
      }
      handleClick({ target }) {
        var card_layout =  document.querySelector('input[name="card_layout"]');
        if (target.classList.contains('active')) {
          return;
        }
        this.buttons.forEach(button => button.classList.toggle('active', button === target));
        card_layout.value = target.value;
        window.updateURLHash({'card_layout': target.value});
        this.updateCards(target.value === "6");
      }
     
      updateCards() {
        this.cards.forEach(card => {
          card.initializeSwiper();
        });
      }
    }
  );
}

